import React from 'react';
import { css } from 'aphrodite';

import { styles as s } from './LoadingSpinner.styles';

const LoadingSpinner = () => (
  <div className={css(s.spinnerWrapper)}>
    <span className={css(s.spinner)}></span>
  </div>
);

export default LoadingSpinner;
